export default __webpack_public_path__ + "static/media/run_normal.52cc9fa2.svg";